import * as React from 'react';
import { Modal } from '@mui/material';
import moment from 'lib/momentTimezone';
import { useIntl } from 'react-intl';
import { SelectedSlot } from '../NearbyLocationsTimeSlots/NearbyLocation/NearbyLocation';
import * as styles from './ConfirmModal.module.scss';

type ConfirmModalProps = {
    showModal: boolean;
    selectedSlot: SelectedSlot | null;
    hideModal: () => void;
    handleSubmit: () => void;
    timezone?: string;
};

export default function ConfirmModal({
    showModal,
    hideModal,
    handleSubmit,
    selectedSlot,
    timezone,
}: ConfirmModalProps) {
    const intl = useIntl();
    const dateTime =
        selectedSlot &&
        timezone &&
        moment
            .tz(selectedSlot.time, moment.defaultFormat, timezone)
            .format('MM/DD [at] h:mm A');
    return (
        <Modal open={showModal}>
            <div className={styles.root}>
                {selectedSlot?.provider && (
                    <>
                        <div className={styles.header}>
                            {intl.formatMessage({
                                id: 'booking.form.date.justToConfirm',
                            })}
                        </div>
                        <div>
                            {intl.formatMessage(
                                {
                                    id: 'booking.form.date.confirmAnyProviderAvailableText',
                                },
                                {
                                    location: selectedSlot?.locationName,
                                    date: dateTime,
                                    strong: ((chunks: string) => (
                                        <strong>{chunks}</strong>
                                    )) as unknown as React.ReactNode,
                                },
                            )}
                        </div>
                    </>
                )}
                {!selectedSlot?.provider && (
                    <>
                        <div>
                            {intl.formatMessage({
                                id: 'booking.form.date.justToConfirm',
                            })}
                        </div>
                        <div>
                            {intl.formatMessage(
                                {
                                    id: 'booking.form.date.confirmOtherClinicLocationText',
                                },
                                {
                                    location: selectedSlot?.locationName,
                                    strong: ((chunks: string) => (
                                        <strong>{chunks}</strong>
                                    )) as unknown as React.ReactNode,
                                },
                            )}
                        </div>
                    </>
                )}
                <div className={styles.modalButtons}>
                    <button
                        onClick={() => hideModal()}
                        className={styles.cancelButton}
                        type="button"
                    >
                        {intl.formatMessage({
                            id: 'booking.form.date.cancel',
                        })}
                    </button>
                    <button
                        onClick={handleSubmit}
                        className={styles.confirmButton}
                        type="button"
                    >
                        {intl.formatMessage({
                            id: 'booking.form.date.confirm',
                        })}
                    </button>
                </div>
            </div>
        </Modal>
    );
}
